import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Wrapper = styled.section`
  .section {
    padding-top: 15%;
    padding-bottom: 9%;

    h2 {
      margin-left: 21px;
      padding-bottom: 3%;
      color: #EC632F;

    }

    .first-p {
      color: #C8C8C8;
      margin-left: 21px;
      margin-right: 106px;
      line-height: 1.3;
    }

    .cards-combo {
      padding-top: 9%;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .card {
      width: 90%;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      border: 1px solid #000;
      padding-bottom: 8%;

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        display: flex;
        margin: 0 auto;
      }

      h3 {
        padding-top: 5%;
        text-align: center;
      }

      p {
        color: #C8C8C8;
        padding-top: 3%;
        text-align: center;
      }
    }

    .card-1 {
      width: 90%;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      padding-bottom: 8%;
      display: none;

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        display: flex;
        margin: 0 auto;
      }

      h3 {
        padding-top: 5%;
        text-align: center;
      }

      p {
        color: #C8C8C8;
        padding-top: 3%;
        text-align: center;
      }
    }
    .card-3 {
      width: 90%;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      padding-bottom: 8%;
      display: none;

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        display: flex;
        margin: 0 auto;
      }

      h3 {
        padding-top: 5%;
        text-align: center;
      }

      p {
        color: #C8C8C8;
        padding-top: 3%;
        text-align: center;
      }
    }

    .card-2 {

width: 30%;
background: red;
display: none;
img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}

h3 {
  padding-top: 5%;
  text-align: center;
}

p {
  color: #C8C8C8;
  padding-top: 3%;
  text-align: center;
}
} 
  }

  @media (min-width: 768px) {
    .section {
      padding-top: 3%;
      padding-bottom: 3%;
      .first-p {
        text-align: center;
        color: #C8C8C8;
        padding: 0 196px;
        line-height: 1.3;
        margin-left: 0;
        margin-right: 0;

      }
      .Carousel{
        display: flex;
      }
      .card-1 {

        width: 30%;
        background: red;
        display: none;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 
      .card-2 {

        width: 50%;
        background: red;
        display: block;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 
      .card {
        width: 50%;

        background: red;
        display: flex;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 

      .cards-combo {
        padding-top: 3%;
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin:  0 25px;
      }

    }
    

      h2 {
        text-align: center;
        margin-left: 0px;
        padding-bottom: 3%;
      }


      
  }

  @media (min-width: 992px) {
    .section {
      padding-top: 3%;
      padding-bottom: 3%;
      .first-p {
        text-align: center;
        color: #C8C8C8;
        padding: 0 196px;
        line-height: 1.3;
        margin-left: 0;
        margin-right: 0;

      }
      .Carousel{
        display: flex;
      }
      .card-1 {

        width: 35%;
        background: red;
        display: block;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 
      .card-2 {

        width: 35%;
        background: red;
        display: block;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 
      .card {
        width: 35%;

        background: red;
        display: flex;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 5%;
          text-align: center;
        }

        p {
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 

      .cards-combo {
        padding-top: 3%;
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin:  0 38px;
      }

    }
    

      h2 {
        text-align: center;
        margin-left: 0px;
        padding-bottom: 3%;
      }


      
  }
  @media (min-width: 1200px) {
    .section {
      padding-top: 0%;
      padding-bottom: 5%;
      .first-p {
        text-align: center;
        color: #C8C8C8;
        padding: 0 196px;
        line-height: 1.3;
        margin-left: 0;
        margin-right: 0;

      }
      .Carousel{
        display: flex;
      }
      .card-1 {
        background: none;
        width: 35%;
        display: block;
        padding-bottom: 3%;

        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: flex;
          margin: 0 auto;
        }

        h3 {
          padding-top: 9%;
          text-align: center;
        }

        p {
          font-size: 16px;
          color: #C8C8C8;
          padding-top: 3%;
          text-align: center;
        }
      } 
     

      .cards-combo {
        padding-top: 3%;
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin: 0 90px;

  
      }

 
.card-3 {
width: 35%;
background: none;
display: block;
padding-bottom: 0;
img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}

h3 {
  padding-top: 9%;
  text-align: center;
}

p {
  font-size: 16px;
  color: #C8C8C8;
  padding-top: 3%;
  text-align: center;
}
} 
.card {
width: 35%;
padding-bottom: 0;
background: none;
display: flex;
img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}

h3 {
  padding-top: 9%;
  text-align: center;
}

p {
  color: #C8C8C8;
  padding-top: 3%;
  text-align: center;
}
} 

.card-2 {
width: 35%;
background: none;
display: block;
padding-bottom: 0px;

img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}

h3 {
  padding-top: 9%;
  text-align: center;
}

p {
  color: #C8C8C8;
  padding-top: 3%;
  text-align: center;
}
} 
    }
    
  
      h2 {
        text-align: center;
        margin-left: 0px;
        font-size: 33px;
  font-weight: 600;
        padding-bottom: 3%;
      }


      
  }
`;

function OurTeam() {
  return (
    <Wrapper>
      <div className="section">
        <h2>Our Team</h2>
        <p className="first-p">Meet the Amazing Team at Favour Pre-School & Day Care Center!</p>

        <div className="cards-combo">
        {/* <Carousel showThumbs={false} autoPlay={true} interval={3000} infiniteLoop={true}> */}

            <div className="card">
              <img src="./photos/manykids.png" alt="" />
              <div className="text-combo">
                <h3>Admin Admin</h3>
                <p>Day Care Teacher</p>
              </div>
            </div>
            <div className="card-1">
              <img src="./photos/manykids.png" alt="" />
              <div className="text-combo">
                <h3>Admin Admin</h3>
                <p>Day Care Teacher</p>
              </div>
            </div>
            <div className="card-2">
              <img src="./photos/manykids.png" alt="" />
              <div className="text-combo">
                <h3>Admin Admin</h3>
                <p>Day Care Teacher</p>
              </div>
            </div>
            <div className="card-3">
              <img src="./photos/manykids.png" alt="" />
              <div className="text-combo">
                <h3>Admin Admin</h3>
                <p>Day Care Teacher</p>
              </div>
            </div>
            {/* </Carousel> */}

        </div>

      </div>
    </Wrapper>
  );
}

export default OurTeam









// import React from 'react'
// import styled from 'styled-components'

// const Wrapper =styled.section`
// .section{
//     padding-top: 15%;
//     padding-bottom: 9%;

// }
// h2{
//     margin-left:21px;
//     padding-bottom: 3%;
// }
// .first-p{
//     color: #C8C8C8;
//     margin-left:21px;
//  margin-right: 106px;
//  line-height: 1.3;
// }
// .cards-combo{
//     padding-top: 9%;
//     display: flex;
//     flex-direction: column;
//     gap: 20px;
// }
// .card{
//     width: 90%;
//     display: flex;
//     flex-direction: column;
//     margin: 0 auto;
// border: 1px solid #000;
//     padding-bottom: 8%;
//     img{
//   width: 100%;
//   height: 200px;
//   object-fit: cover;
//   display: flex;
//   margin: 0 auto;
// }
// h3{
//     padding-top: 5%;
//     text-align: center;
// }
// p{
//     color: #C8C8C8;
//     padding-top: 3%;
//     text-align: center;
// }
// }


// .card-1{
//     width: 90%;
//     display: flex;
//     flex-direction: column;
//     margin: 0 auto;
//     padding-bottom: 8%;
//     display: none;
//     img{
//   width: 100%;
//   height: 200px;
//   object-fit: cover;
//   display: flex;
//   margin: 0 auto;
// }
// h3{
//     padding-top: 5%;
//     text-align: center;
// }
// p{
//     color: #C8C8C8;
//     padding-top: 3%;
//     text-align: center;
// }
// }



// @media (min-width: 768px) {
//     .section{
//     padding-top: 3%;
//     padding-bottom: 3%;

// }
//     .card-1{
//     width: 90%;
//     display: flex;
//     flex-direction: column;
//     margin: 0 auto;
//     padding-bottom: 8%;
//     display: block;
//     img{
//   width: 100%;
//   height: 200px;
//   object-fit: cover;
//   display: flex;
//   margin: 0 auto;
// }
// h3{
//     padding-top: 5%;
//     text-align: center;
// }
// p{
//     color: #C8C8C8;
//     padding-top: 3%;
//     text-align: center;
// }
// }
// .cards-combo{
//     padding-top: 3%;
//     display: flex;
//     flex-direction: row;
//     gap: 20px;
// }
// .first-p{
//     margin-left: 0;
//     margin-right: 0;
//     text-align: center;
//     color: #C8C8C8;
//     padding: 0 226px;
//  line-height: 1.3;
// }
// h2{
//     text-align: center;
//     margin-left:0px;
//     padding-bottom: 3%;
// }
// }
// `
// function OurTeam() {
//   return (
//     <Wrapper>
//       <div className='section'>
//         <h2>Our Team</h2>
//         <p className='first-p'>Meet the Amazing Team at Favour Pre-School & Day Care Center!</p>
//     <div className='cards-combo'>

//             <div className='card'>
//             <img src="./photos/manykids.png" alt=""/>
//                 <div className='text-combo'>
//                     <h3>Admin Admin</h3>
//                     <p>Day Care Teacher</p>
//                 </div>
//             </div>
//                         {/* end  */}

//             <div className='card-1'>
//             <img src="./photos/manykids.png" alt=""/>
//                 <div className='text-combo'>
//                     <h3>Admin Admin</h3>
//                     <p>Day Care Teacher</p>
//                 </div>
//             </div>

//             {/* end  */}
//             <div className='card-1'>
//             <img src="./photos/manykids.png" alt=""/>
//                 <div className='text-combo'>
//                     <h3>Admin Admin</h3>
//                     <p>Day Care Teacher</p>
//                 </div>
//             </div>
//                         {/* end  */}

//             <div className='card-1'>
//             <img src="./photos/manykids.png" alt=""/>
//                 <div className='text-combo'>
//                     <h3>Admin Admin</h3>
//                     <p>Day Care Teacher</p>
//                 </div>
//             </div>
//                         {/* end  */}

//      </div>
        
//       </div>
//     </Wrapper>
//   )
// }

// export default OurTeam
